const img = require('./play.png'); export default img;